import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i2 from 'ngx-bootstrap/tooltip';
import { TooltipDirective, TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';
import * as i1 from 'ngx-bootstrap/component-loader';
import * as i3 from 'ngx-bootstrap/positioning';
class OverflowTooltipDirective extends TooltipDirective {
  constructor(viewContainerRef, cis, config, elementRef, renderer, positionService) {
    super(viewContainerRef, cis, config, elementRef, renderer, positionService);
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.defaultContainerClass = 'cxone-tooltip-container';
    this.overflowTooltip = cis.createLoader(this.elementRef, viewContainerRef, this.renderer).provide({
      provide: TooltipConfig,
      useValue: config
    });
  }
  ngOnInit() {
    super.ngOnInit();
    this.setDefaults();
    this.overflowTooltip.listen({
      triggers: this.triggers,
      show: () => {
        if (this.enableTooltipIfOverflow()) {
          this.isDisabled = false;
          super.show();
        }
        this.isDisabled = true;
      }
    });
  }
  ngOnChanges() {
    this.setDefaults();
  }
  ngAfterViewChecked() {
    if (!this.tooltipContent) {
      this.tooltip = this.elementRef.nativeElement.innerText;
    }
  }
  enableTooltipIfOverflow() {
    const element = this.elementRef.nativeElement;
    const isElementOverflow = this.checkOverFlowCondition(element);
    const parent = this.renderer.parentNode(element);
    const isParentOverflow = this.checkOverFlowCondition(parent);
    return isElementOverflow || isParentOverflow;
  }
  checkOverFlowCondition(element) {
    const width = element.clientWidth;
    this.renderer.setStyle(element, 'maxWidth', 'max-content');
    this.renderer.setStyle(element, 'width', 'max-content');
    const maxWidth = element.clientWidth;
    this.renderer.setStyle(element, 'maxWidth', '');
    this.renderer.setStyle(element, 'width', '');
    return width < maxWidth;
  }
  ngOnDestroy() {
    this.overflowTooltip.dispose();
    super.ngOnDestroy();
  }
  setDefaults() {
    if (!this.containerClass) {
      this.containerClass = this.defaultContainerClass;
    }
    if (!this.container) {
      this.container = 'body';
    }
    this.isDisabled = true;
    if (this.tooltipContent) {
      this.tooltip = this.tooltipContent;
    } else {
      this.tooltip = this.elementRef.nativeElement.innerText;
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function OverflowTooltipDirective_Factory(t) {
      return new (t || OverflowTooltipDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.ComponentLoaderFactory), i0.ɵɵdirectiveInject(i2.TooltipConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i3.PositioningService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OverflowTooltipDirective,
      selectors: [["", "cxoneOverflowTooltip", ""]],
      inputs: {
        tooltipContent: "tooltipContent"
      },
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverflowTooltipDirective, [{
    type: Directive,
    args: [{
      selector: '[cxoneOverflowTooltip]'
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: i1.ComponentLoaderFactory
  }, {
    type: i2.TooltipConfig
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i3.PositioningService
  }], {
    tooltipContent: [{
      type: Input
    }]
  });
})();
class OverflowTooltipModule {
  /** @nocollapse */static {
    this.ɵfac = function OverflowTooltipModule_Factory(t) {
      return new (t || OverflowTooltipModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OverflowTooltipModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TooltipModule.forRoot()]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverflowTooltipModule, [{
    type: NgModule,
    args: [{
      declarations: [OverflowTooltipDirective],
      imports: [CommonModule, TooltipModule.forRoot()],
      exports: [OverflowTooltipDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OverflowTooltipDirective, OverflowTooltipModule };
